import { useLoaderData } from "@tanstack/react-router"

import type { CompanyLocationAssociation, Location } from "@/graphql/codegen/graphql"
import type { PurchaseOrderForm } from "@/screens/Procurement/PurchaseOrder/types"

interface UseCurrentPODataReturn {
  purchaseOrder: PurchaseOrderForm
  companyLocationAssociations: CompanyLocationAssociation[]
  shipFromLocation: Location | null
}

const useCurrentPOData = (): UseCurrentPODataReturn => {
  const { purchaseOrder, companyLocationAssociations, shipFromLocation } = useLoaderData({
    from: "/app/procurement/_layout_/purchase-orders/$purchaseOrderId",
  })
  return {
    shipFromLocation,
    purchaseOrder,
    companyLocationAssociations,
  }
}

export default useCurrentPOData
